// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"affirm_ko-KR__mWHKi","impressionTrackingContainer":"affirm_impressionTrackingContainer__6myVy","affirmIframe":"affirm_affirmIframe__BoxsN"};